import React, { useState, useEffect } from "react";
import Header from "../../../componentes/header/header";
import FinalComponent from "../../../componentes/EndPage/Final";
import JsonData from "./Ebooks.json";  
import Imagens from "./imagens.json"; 
import translations from "./Ebooks.json"; 

function Ebooks() {
    const [currentLanguage, setCurrentLanguage] = useState(localStorage.getItem("siteLanguage") || 'pt'); 

    const handleLanguageChange = (newLang) => {
        setCurrentLanguage(newLang);
        localStorage.setItem("siteLanguage", newLang); 
        window.location.reload(); 
    };

    useEffect(() => {
        const browserLang = navigator.language.split("-")[0]; 
        const supportedLanguages = ['pt', 'en', 'es']; 
        const savedLang = localStorage.getItem("siteLanguage");

        if (!savedLang) {
            if (supportedLanguages.includes(browserLang)) {
                setCurrentLanguage(browserLang); 
                localStorage.setItem("siteLanguage", browserLang);
            } else {
                setCurrentLanguage('pt'); 
                localStorage.setItem("siteLanguage", 'pt'); 
            }
        }
    }, []); 

    const translation = translations[currentLanguage];

    return (
        <>
            <Header handleLanguageChange={handleLanguageChange} />
            <h1 className="
                text-[4vh] text-[#B040B1] inline-block relative font-bold
                mt-[0vh] mb-[2vh] 
                max-[480px]:mt-[14vh]
                max-[768px]:mt-[12vh]
                max-[1024px]:mt-[8vh]
                max-[1440px]:mt-[6vh]
            ">
                {translation?.ebooksTitle || "E-books"}
                <span className="absolute bottom-[-8px] left-[-35px] w-[150%] h-[5px] bg-gradient-to-r from-[#6A0DAD] to-[#FF66B2] rounded-[2px]"></span>
            </h1> 

            <div>
                {JsonData[currentLanguage].map((item, index) => ( 
                    <div key={index} className="bg-white p-5 m-5 mx-auto text-left rounded-[10px] shadow-[0px_4px_10px_rgba(0,0,0,0.2)] border-l-[5px] border-l-[#6A0DAD] max-w-[60%] mb-[6%] w-[90%] z-0">
                        <h2 className="text-[1.5em] font-bold text-[#6A0DAD] mb-[10px]">{item.name}</h2>
                        <p>{item.Content}</p>
                        <a href={item.linker} className="block mt-[10px] text-[#B040B1] text-[20px] no-underline font-bold underline break-words" target="_blank" rel="noopener noreferrer">
                            {item.Acesse}
                            <img src={Imagens[index]?.img} alt={item.name} className="block mx-auto pt-[5%] max-w-full"/>
                        </a>
                    </div>
                ))}
            </div>

            <FinalComponent />
        </>
    );
}

export default Ebooks;
